import 'babel-polyfill';
import Vue from 'vue';
import VModal from 'vue-js-modal';
import vSelect from 'vue-select';
import Vue2Filters from 'vue2-filters';
import Vuelidate from 'vuelidate';
import VueMoment from 'vue-moment';
import * as VueSpinnersCss from 'vue-spinners-css';
import moment from 'moment';
import VTooltip from 'v-tooltip';
import dotToComma from './directives/dotToComma';
import App from './App.vue';
import router from './router';
import { store } from './store';
import i18n from './plugins/i18n';
import fontawesome from './plugins/fontawesome/fontawesome'; // eslint-disable-line
import BaMxFormatter from '@/components/mixins/bu-mx-formatter';
import 'ie-string-startswith-polyfill';
import 'custom-event-polyfill';


import '@hokify/vuejs-datepicker/dist/vuejs-datepicker.css';

import 'moment/locale/nl';
import 'moment/locale/en-gb';
import 'moment/locale/fr';


Vue.prototype.moment = moment;


Vue.use(VueSpinnersCss);
Vue.use(VTooltip);

Vue.directive('dotToComma', dotToComma);

Vue.component('v-select', vSelect);

Vue.use(VueMoment);
Vue.use(Vuelidate);
Vue.mixin(BaMxFormatter);

Vue.config.productionTip = false;

Vue.use(VModal, {
  dynamic: true,
  dynamicDefaults: {
    clickToClose: false,
  },
  height: 'auto',
  componentName: 'ba-modal',
  injectModalsContainer: true,
});

Vue.use(Vue2Filters);

Vue.mixin(BaMxFormatter);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
